import asArray from 'utils/arrays/asArray.util';
import alwaysSame from 'utils/functions/nullary/alwaysSame.util';

/**
 * @param value
 * @return {*[]}
 */
const noNilArray = (value) => asArray(value).filter(alwaysSame);

// noinspection JSUnusedGlobalSymbols
export default noNilArray;
